import { useRef, type RefObject, type CSSProperties } from 'react';
import { useDragLayer, type XYCoord } from 'react-dnd';
import { DraggingItem } from './DraggingItem';
import { isCategoryItem, isScenesItem, isSubCategoryItem } from '../dnd';
import { DraggingCategory } from './DraggingSubCategory';

export function DragLayer() {
  const { itemType, isDragging, item, clientOffset } = useDragLayer(
    (monitor) => ({
      item: monitor.getItem(),
      itemType: monitor.getItemType(),
      clientOffset: monitor.getClientOffset(),
      isDragging: monitor.isDragging(),
    })
  );

  const containerRef = useRef<HTMLDivElement>(null);

  function renderItem() {
    if (isScenesItem(item, itemType)) {
      return <DraggingItem ids={item.ids} />;
    }
    if (isSubCategoryItem(item, itemType)) {
      return <DraggingCategory id={item.id} isSub />;
    }
    if (isCategoryItem(item, itemType)) {
      return <DraggingCategory id={item.id} isSub={false} />;
    }

    return null;
  }

  if (!isDragging) return null;

  return (
    <div className="pointer-events-none fixed inset-0 z-50" ref={containerRef}>
      <div style={getItemStyles({ clientOffset, containerRef })}>
        {renderItem()}
      </div>
    </div>
  );
}

function getItemStyles({
  clientOffset,
  containerRef,
}: {
  /** 鼠标实时位置 */
  clientOffset: XYCoord | null;
  containerRef: RefObject<HTMLDivElement>;
}): CSSProperties {
  if (!clientOffset || !containerRef.current) {
    return {
      display: 'none',
    };
  }
  const { x: containerX, y: containerY } =
    containerRef.current.getBoundingClientRect();

  return {
    position: 'absolute',
    top: clientOffset.y - containerY,
    left: clientOffset.x - containerX,
  };
}

export default DragLayer;
